const CitiesList = () => import('../screens/Cities/List/CitiesList.vue');

export default [
  {
    component: CitiesList,
    meta: {
      activeSidebarItemId: 'cities',
      pageTitle: 'Cities',
    },
    name: 'cities',
    path: '/cities',
  },
];
